import { render, staticRenderFns } from "./ListScreen.vue?vue&type=template&id=83eea344&scoped=true&"
import script from "./ListScreen.vue?vue&type=script&lang=js&"
export * from "./ListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eea344",
  null
  
)

export default component.exports